const toggleSidebar = () => {
	return { type: 'TOGGLE_SIDEBAR' };
};

const data = {
	toggleSidebar,
};
export default data;
